export default __webpack_public_path__ + "static/media/avatar.827a0db4.jpg";